import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Theme } from '../../shared/service/AutoTheme';

@Component({
  selector: 'app-dialpersonal',
  templateUrl: './dialpersonal.component.html',
  styleUrls: ['./dialpersonal.component.css']
})
export class DialpersonalComponent implements OnInit {

  public selectedKey: any = []; 
  public myJSON:any;
  public DateString:string;
  constructor(public dialog: MatDialogRef<DialpersonalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public theme:Theme) { }

  ngOnInit() {}
  
  onClick(sdata: string)
  { 
    this.selectedKey.push(sdata);
    this.myJSON = JSON.stringify(this.selectedKey);
    this.DateString =this.myJSON.replace(/[\[\],"]+/g,"");
    console.log(this.DateString);
    if(this.data.dialstatus)
    {
      this.theme.SendDTMFSip(parseInt(sdata));
    }
    
  }

  Call(DateString:string)
  {   
    if(DateString.length > 9)
    {     
      if(DateString.length > 10)
      {
        this.theme.DialPersonalNo(DateString);
        this.theme.SaveDialPersonalNo(JSON.stringify({number:DateString})); 
        this.dialog.close(DateString);
      }
      else
      {
        DateString = "1"+DateString;
        this.theme.DialPersonalNo(DateString);
        this.theme.SaveDialPersonalNo(JSON.stringify({number:DateString})); 
        this.dialog.close(DateString);
      }
     
    }
    else
      alert("Invalid Number.");    
  }

  back()
  {
  console.log(this.selectedKey.pop());
  this.myJSON = JSON.stringify(this.selectedKey);  
  this.DateString =this.myJSON.replace(/[\[\],"]+/g,""); 
  }

  Close()
  {
    this.dialog.close();
  }
}
